import React from "react";
import StepContent from "../../components/step-content";
import { PlanType } from "../../components/enums/plan-type";
import HealthPlan from "../../components/health-plan";

const Dental = ({ pageStep }) => {
  return (
    <HealthPlan
      pageStep={pageStep}
      defaultPlanId="WAIVED"
      defaultPlanDescription="Waived Coverage"
      waivedOption="0"
      planType={PlanType.Dental}
    />
  );
};

export default Dental;
